export const extractCommentByIds = (comments, idList) => {
    const filteredCommentList = [];

    idList.forEach(commentId => {
        filteredCommentList.push(comments[commentId]);
    });

    return filteredCommentList;
};
